import styled from '@emotion/styled';
import * as Accordion from '@radix-ui/react-accordion';

import { slideDown, slideUp } from '@/styles/keyframes/slide';

export const AccordionRoot = styled(Accordion.Root)`
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  margin-top: 16px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;

export const AccordionItem = styled(Accordion.Item)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.zinc_200};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const AccordionTrigger = styled(Accordion.Trigger)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
`;

export const AccordionContent = styled(Accordion.Content)`
  padding: 0 16px 16px;

  &[data-state='closed'] {
    animation: ${slideUp('var(--radix-collapsible-content-height)')} 0.15s
      ease-in-out;
  }
  &[data-state='open'] {
    display: flex;
    flex-direction: column;
    animation: ${slideDown('var(--radix-collapsible-content-height)')} 0.15s
      ease-in-out;
    gap: 8px;
  }
`;

export const Ol = styled.ol`
  display: flex;
  flex-direction: column;
  padding-left: 16px;
  gap: 8px;
`;

export const Li = styled.li<{ height?: number }>`
  height: ${({ height }) => `${height}px` ?? 'auto'};

  &::marker {
    color: ${({ theme }) => theme.colors.black};
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
  }
`;

export const A = styled.a`
  display: flex;
  align-items: center;
`;
